export function GetSupportIDCtrl ($http, $uibModalInstance, $scope, $window, confirm, messages, workshopAPI, company) {
  $scope.company = company;

  workshopAPI.get('/workshop_admin/supportTypes').then(function (data) {
    $scope.record_type_list = data.qbo_record_types;
  });

  $scope.search = {
    record_type: '',
    reference: '',
    confirm: function () {
      workshopAPI.get('/workshop_admin/get_id_for_support', [$scope.company.id, this.record_type, this.reference]).then(function(data) {
        $uibModalInstance.close(data);
      }, function (err) {
        messages.error(err);
      })
    }
  };
}